import * as singleSpa from "single-spa"
import { coreStore, SET_ACTIVE_MENU } from "@forcepoint/platform-coreui"
export const subMenuItemClick = (menuItem: any, appData, setNestedMenuOpen) => {
  // Open external menu links in a new tab.
  // url is optional (parent nodes that only hold nested menus have none) —
  // the missing ?. crashed the whole sidebar subtree on click.
  if (menuItem?.url?.startsWith("http")) {
    window.open(menuItem?.url, "_blank", "noopener,noreferrer")
    return
  }
  // Contact support pages are handled by navigationui — bypass old-iframe routing
  if (menuItem?.url?.endsWith("/contact-support")) {
    setNestedMenuOpen(false)
    singleSpa.navigateToUrl(menuItem?.url)
    return
  }
  const stateData = coreStore.getState()

  // Only executes when old iframe is used
  if (!stateData.useNewIframe && appData.openInIframe && !menuItem?.menus) {
    if (stateData?.activeApp?.applicationCode !== appData.applicationCode) {
      singleSpa.navigateToUrl(appData?.applicationURL)
    }
    coreStore.dispatch({
      type: SET_ACTIVE_MENU,
      url: menuItem?.url
    })
    const iFrame: any = document.getElementById("app-iframe")

    /* Passing state data from parent to child iframeurl */
    if (iFrame) {
      const checkURLSplit = stateData.activeApp.iframeURL.split("/")
      const checkURL = `${checkURLSplit[0]}//${checkURLSplit[2]}`
      iFrame.contentWindow?.postMessage(
        {
          message: "MENU_ITEM_CLICK",
          detail: { application: appData, menu: menuItem }
        },
        checkURL
      )
    }
  } else if (menuItem?.menus?.length > 0) {
    setNestedMenuOpen((nestedMenuOpen) => !nestedMenuOpen)
  } else {
    setNestedMenuOpen(false)
    singleSpa.navigateToUrl(menuItem?.url)
  }

  // Skipping dispatching event to window if the app is loaded in iframe and there are submenus
  // This prevents iframeui from performing routing when a submenu with further nested menus is clicked
  if (appData.openInIframe && menuItem?.menus?.length > 0) return

  const event = new CustomEvent("menuItemClick", {
    detail: { application: appData, menu: menuItem }
  })
  window.dispatchEvent(event)
}

/**
 *
 * @param activeAppCode the code of the active application
 * @param currentApp the current application object
 * @returns true if the current app is active, false otherwise
 */
export const isAppActive = (activeAppCode, currentApp) => {
  return (
    (window.location.pathname.startsWith("/settings") &&
      currentApp.applicationName === "Settings") ||
    (window.location.pathname.startsWith("/home") &&
      currentApp.applicationName === "Home") ||
    (activeAppCode === currentApp.applicationCode &&
      !window.location.pathname.startsWith("/settings"))
  )
}
